import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Route, Routes } from "react-router-dom";

import LandingPage from "./components/AuthPages/Landing/LandingPage";
import AllRoutes from "./routes/routes";
import AuthenticatedBaseFilters from "./components/AuthenticatedBaseFilters";

import "@fontsource/inter";
import "./css/utility.scss";

const theme = createTheme({
  typography: {
    fontFamily: "Inter, sans-serif",
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <AuthenticatedBaseFilters />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/*" element={<AllRoutes />} />
      </Routes>
    </ThemeProvider>
  );
};

export default App;
